<template>
  <div class="saohei_page" :class="['main-page saohei_page', { xiaodu: isXiaodu }]">
    <Menus title="扫黑除恶专题" bgclass="saohei" />
    <div class="saohei_content" :style="{ 'margin-top': isXiaodu && '110px' }">
      <div class="saoheileft">
        <div class="imgs">
          <img src="/img/ui/saohei/saohei_icon.png" alt="">
        </div>
      </div>
      <div class="scroll-box">
        <div id="container" class="list-box">
          <div class="message-container message-avatar">
            <Avata img="https://qiniu.laway.cn/fc096e7c51fa11e9ab49525400436b39.png" />
            <div class="message-items">
              <div class="content" v-html="guide_desc">
              </div>
            </div>
          </div>
          <div class="message-container message-avatar">
            <Avata img="https://qiniu.laway.cn/fc096e7c51fa11e9ab49525400436b39.png" />
            <div v-if="questions && questions.length" class="message-items">
              <div class="hts">
                热门{{ title }}问题
              </div>
              <ul class="list">
                <li v-for="(item, index) in questions" :key="'key-rel-question-' + index">
                  <a href="javascript:;" @click="sendmessage(item.content, item.id)">{{ item.content }}</a>
                </li>
              </ul>
            </div>
          </div>
          <ChatTest v-for="(msg, index) in messages" :key="'msg' + index" :ask="ask" :label="msg.label" :sent="msg.sent"
            :text-color="msg.textColor" :bg-color="msg.bgColor" :name="msg.name" :avatar="msg.avatar" :text="msg.text"
            :questiontype="msg.type" :stamp="msg.stamp" @sendmsg="sendmessage" @sendoption="sendmessage"
            @sendoptions="sendmessage" @setContent="setContent" @getCase="getCaseContent" @setScrollTop="setScrollTop"
            @scrollControll="scrollControll" @openPopover="openPopover" />
          <div v-if="loading" class="message-container message-avatar">
            <Avata img="https://qiniu.laway.cn/fc096e7c51fa11e9ab49525400436b39.png" />

            <div class="message-items message-items-inline">
              <div class="content">
                <svg fill="currentColor" width="20px" height="20px" viewBox="0 0 120 30"
                  xmlns="http://www.w3.org/2000/svg" class="q-spinner" style="display:block">
                  <circle cx="15" cy="15" r="11.4986">
                    <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear"
                      repeatCount="indefinite" />
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                      calcMode="linear" repeatCount="indefinite" />
                  </circle>
                  <circle cx="60" cy="15" r="12.5014" fill-opacity=".3">
                    <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear"
                      repeatCount="indefinite" />
                    <animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5"
                      calcMode="linear" repeatCount="indefinite" />
                  </circle>
                  <circle cx="105" cy="15" r="11.4986">
                    <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear"
                      repeatCount="indefinite" />
                    <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1"
                      calcMode="linear" repeatCount="indefinite" />
                  </circle>
                </svg>
              </div>
            </div>
          </div>
          <div v-if="ask && ask.show">
            <div v-if="ask.input_type === 1" class="options">
              <a v-for="(askn, idx) in ask.children" :key="'key-ask-' + idx" href="javascript:;"
                class="btn btn-outline btn-primary" @click="sendmessage(askn.title)">{{ askn.title }}</a>
            </div>

            <div v-if="ask.input_type === 2" class="options">
              <a v-for="(asks, idx) in ask.children" :key="'key-ask-' + idx" href="javascript:;"
                :class="{ 'btn btn-outline btn-primary': !ask.item[idx], 'btn btn-primary': ask.item[idx] }"
                @click="getOption(asks.input_type, asks.title, idx)">{{ asks.title }}</a>
              <a href="javascript:;" :class="{ 'btn btn-success': is_check_option, 'btn btn-default': !is_check_option }"
                @click="getOptionSend">提交选项</a>
            </div>

            <div v-if="ask.input_type === 32" class="options">
              <div class="btn btn-outline btn-primary" @click="area.show = true">
                选择区域
              </div>
            </div>
            <div v-if="ask.input_type === 31" class="options">
              <div class="btn btn-outline btn-primary" @click="date.show = true">
                选择时间
              </div>
            </div>
          </div>
          <YPopover v-if="popover.show" v-model="popover" @close="popover.show = false" />
        </div>
        <div ref="enterInput" class="input-box">
          <input v-model="message" type="text" placeholder="亲爱哒，请在这里输入相关问题，我会快速回复您哒！">
          <button @click="sendmessage(message)">
            发送
          </button>
        </div>
        <!-- 停止朗读 -->
        <div v-if="isreading" class="stopreading" @click="stopRading">
          <img src="/img/ui/saohei/laba.png" alt="">
        </div>
      </div>

      <!-- 右边 -->
      <div class="saoheiright">
        <div class="title">
          扫黑除恶专项斗争相关问答
        </div>
        <div class="content">
          <div v-for="(item, index) in saoheilist" :key="'key-' + index" class="item">
            <div class="item-title">
              {{ item.title }}
            </div>
            <ul>
              <li v-for="(answer, idx) in item.list" :key="'key-dd' + idx" @click="sendmessage(answer.title)">
                <span class="icon-dots">•</span>
                {{ answer.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-right">
      <YSelectArea v-if="area.show" v-model="area" @close="area.show = false" @submit="setArea" />
    </transition>
    <transition name="slide-down">
      <YSelectDate v-if="date.show" v-model="date" @close="date.show = false" @submit="setArea" />
    </transition>
    <CaseDialog v-model="cases.show" :content="cases.content" />
    <Dialogs v-model="dialog">
      <div class="body">
        <div class="report-message">
          <div class="item">
            <div class="item-title">
              云南省
            </div>
            <div class="content">
              <div class="desc">
                举报电话
              </div>
              <div class="desc-item">
                （0871）63992898（省扫黑办）
              </div>
              <div class="desc-item">
                （0871）12368（省高级人民法院）
              </div>
              <div class="desc-item">
                （0871）64993142（省人民检察院）
              </div>
              <div class="desc-item">
                （0871）63053110（省公安厅）
              </div>
              <div class="desc-item">
                （0871）64189050（省司法厅）
              </div>
              <div class="desc">
                举报邮箱
              </div>
              <div class="desc-item">
                ynshcebgs@163.com
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              昆明市
            </div>
            <div class="content">
              <div class="desc">
                举报电话
              </div>
              <div class="desc-item">
                （0871）67432485（市扫黑办）
              </div>
              <div class="desc-item">
                （0871）64096532（市中级人民法院）
              </div>
              <div class="desc-item">
                （0871）65701000（市人民检察院）
              </div>
              <div class="desc-item">
                （0871）63015198（市公安局）
              </div>
              <div class="desc-item">
                （0871）63139895（省司法局）
              </div>
              <div class="desc">
                举报邮箱
              </div>
              <div class="desc-item">
                kmshcebgs@163.com
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              西山区
            </div>
            <div class="content">
              <div class="desc">
                举报电话
              </div>
              <div class="desc-item">
                （0871）68226838（区扫黑办）
              </div>
              <div class="desc-item">
                （0871）68179215（区公安局）
              </div>
              <div class="desc">
                举报邮箱
              </div>
              <div class="desc-item">
                xsshcebgs@163.com
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="foot">
        <div />
      </template>
    </Dialogs>
  </div>
</template>
<script>
import Menus from '@/components/Menu.vue'
import Dialogs from '@/components/Dialog'
import { speak } from '@/datas/js/common'
import Base64 from './saoheicomponents/js/base64.js'
import Avata from './saoheicomponents/Avatar'
import ChatTest from './saoheicomponents/SaoHeiChatTest'
import CaseDialog from './saoheicomponents/CaseDialog'
import YPopover from './saoheicomponents/YPopover'
import placeholder from './saoheicomponents/js/input.js'
import YSelectArea from './saoheicomponents/YSelectArea'
import YSelectDate from './saoheicomponents/YSelectDate'
import saoheilist from './saoheicomponents/js/saoheilist.js'
import request from './saoheicomponents/js/request'
import { setToken, getToken, validataOS, delay, getCoverString, getCoverJson } from './saoheicomponents/js/saohei.js'
import { SAOHEI_INQUIRE } from '../../datas/constants/statistics.js'
import chineseTo from 'chinese-s2t'

export default {
  components: {
    Menus,
    Avata,
    ChatTest,
    CaseDialog,
    YPopover,
    YSelectDate,
    YSelectArea,
    Dialogs
  },
  data () {
    return {
      // pid: '5a0432c536aec54741a3ddf4',  // 婚姻
      pid: '5c7736a336aec54cbc4ad24e', // 扫黑
      recount: '',
      os: validataOS(),
      isXiaodu: localStorage.getItem('xiaodu') || false,
      oid: 0,
      saoheilist,
      title: '扫黑除恶',
      questions: '',
      is_voice: false,
      loading: false,
      test: true,
      message: '',
      messages: [],
      config: null,
      // 问题
      ask: {
        input_type: '',
        children: '',
        item: {},
        show: false
      },
      input: {
        type: 0,
        placeholder: '',
        reset: false
      },
      date: {
        show: false,
        selected: '',
        record: []
      },
      area: {
        show: false,
        selected: '',
        record: []
      },
      // 1常规回答，有答案； 2常规回答，没有答案； 3常规回答+有答案+抛出问题； 4常规回答+没有答案+抛出问题；； 5仅抛出答案； 6做题结束，没有报告内容； 7报告内容
      question_type: '',
      // 相关搜索
      question_like: {
        show: false,
        list: [],
        index: -1
      },
      // 详细内容
      reports: {
        show: false,
        content: '',
        current: 0
      },
      cases: {
        content: '',
        show: false
      },
      scroll_top: 0,
      touch: false,
      recorder: {},
      blob: {},
      start: 0,
      end: 0,
      popover: {
        pos: '',
        content: '',
        title: '',
        show: false,
        type: ''
      },
      dialog: {
        show: false,
        title: '',
        close: true
      },
      isreading: false
    }
  },
  computed: {
    guide_desc () {
      let desc = this.$root.xiaoconfig.guide_desc
      return desc.replace(/<strong .*>(.+)<\/strong>/, ($0, $1) => { return $0.replace($1, this.title) })
    },
    is_check_option () {
      return JSON.stringify(this.ask.item) !== '{}'
    }
  },
  async mounted () {
    this.$root.getStatistics(SAOHEI_INQUIRE)
    let puid = 'f0dfa764354cdefef7377bcdc7ae6065'
    // this.pid = pid ? pid : this.pid // eslint-disable-line
    // await delay(1000)
    if (puid && puid.length === 32) {
      const res = await this.$getXiaoConfig(puid)
      this.$root.xiaoconfig = res
      console.log('xiaoconfig:', this.$root.xiaoconfig)

      let text = '云南'
      let reg = new RegExp(text, 'g')
      this.$root.xiaoconfig.guide_desc = this.$root.xiaoconfig.guide_desc.replace(reg, '')

      this.$root.puid = puid
      document.title = res.short_name
    } else {
      console.log('puid')
    }
    await this.getHotList()
    // 滚动时清除百科弹出层
    const _this = this
    this.$nextTick(() => {
      $('#container').scroll(function (e) { //eslint-disable-line
        const pop = $('.popovers') //eslint-disable-line
        const { top } = _this.popover.pos
        // 如果没有弹出层组件，则停止
        if (!pop.length) return
        // 如果pop是在底部
        // console.log($(this).scrollTop() + $('#container').height() - $('.popover .wrap').height() - 94< top - 135 - 42)//eslint-disable-line
        if (pop.find('.wrap').hasClass('top')) {
          if (top < $(this).scrollTop() || $(this).scrollTop() + $('#container').height() - $('.popovers .wrap').height() - 94 < top - 135 - 42) { //eslint-disable-line
            _this.popover.show = false
          }
          // 如果pop是在顶部
        } else {
          if ($(this).scrollTop() + $('.popovers .wrap').height() > top || $(this).scrollTop() + $('#container').height() < top + $('.popovers .wrap').height() - 135 - 42) { //eslint-disable-line
            _this.popover.show = false
          }
        }
      })
    })
  },
  methods: {
    // 获取热门问题
    async setPid (item) {
      this.$loading.show()
      this.title = item.title
      this.pid = item.id
      this.messages = []
      await this.getHotList()
      this.$loading.hide()
      // const h = document.documentElement.clientHeight || document.body.clientHeight
    },
    async getHotList () {
      let { data } = await request.get('https://xiaoxiangs.laway.cn/relate/?pid=' + this.pid)
      // 如果请求错误了，结束
      if (!data.status) {
        console.log('err:' + data.msg)
        return
      }
      // 添加热门问题
      this.questions = data.result.item

      // 设置token, 设置头文件
      if (data.result.token && !getToken()) {
        setToken(data.result.token, '365d', true)
        request.defaults.headers.common['AUTHORIZATION'] = 'Guest ' + data.result.token
      }
    },
    // 请求结果
    async sendmessage (message, oid = 0) {
      let msglist = ''
      const _this = this

      if (this.ask.input_type === 2 || this.ask.input_type === 32) {
        msglist = getCoverString(message, this.ask.input_type)
      }

      if (typeof message === 'string') {
        message.replace(/\s+/g, '').replace(/[\r\n]/g, '')
      } else {
        message = getCoverJson(message, this.ask.input_type)
      }
      // 回车时判断是否有数据，没有停止更新
      if (this.question_type < 5 && !message.trim()) {
        this.message = ''
        return
      }

      // 相关搜索
      // const { show, index, list } = this.question_like
      // if (show && index >= 0) {
      //   message = list[index].content
      //   oid = list[index].id
      // }

      // 如果message为空，则停止
      if (!message) return
      // 添加提问
      await this.addMessage({
        text: [{ content: msglist || message }],
        sent: true,
        avatar: 'statics/linux-avatar.png',
        bgColor: 'primary',
        textColor: 'white'
      })
      this.loading = true

      this.setAsk() // 清空做题
      this.clearQuestionLike() // 清空相关搜索
      this.message = ''
      // this.$nextTick(this.setScrollTo) // 聊天滚动到底部
      this.input = {
        // 清空输入框提示
        type: 0,
        placeholder: '',
        reset: false
      }

      // 请求答案
      const clicode = this.$root.xiaoconfig && this.$root.xiaoconfig.hash_key ? this.$root.xiaoconfig.hash_key : '' // 提交时对平台进行统计
      // const clicode = 'd7058ebe805211e8b4355254001c3480'
      const { data } = await request({
        url: 'https://xiaoxiangs.laway.cn/smart/communicate/?ct=2',
        // url: '/smart/communicate/',
        method: 'post',
        data: {
          id: oid || '',
          q: chineseTo.t2s(message),
          pid: _this.pid || '',
          clicode
        }
      })

      // 请求错误，return
      if (data.status !== 1) {
        console.log('Log: 返回状态码为' + data.status)
        this.loading = false
        return
      }
      // 请求成功
      let {
        type,
        ask,
        bq,
        content,
        baike,
        report_content: reportContent
      } = data.result

      // 为内容添加百科注解
      if (baike.length && data.result.report_content) {
        data.result.report_content = this.baikeFilter(reportContent, baike)
      }
      // 为内容添加百科注解
      if (baike.length && content) {
        data.result.content = this.baikeFilter(content, baike)
      }

      // 为内容过滤网址为配置项网址
      if (this.$root.xiaoconfig && this.$root.xiaoconfig.lvpin_domain) {
        var reg = new RegExp('http://ai.12348.gov.cn/', 'g')
        var reg1 = new RegExp('https://ai.12348.gov.cn/', 'g')
        data.result.content = data.result.content.replace(reg, this.$root.xiaoconfig.lvpin_domain)
        data.result.content = data.result.content.replace(reg1, this.$root.xiaoconfig.lvpin_domain)
        data.result.content = data.result.content.replace(/target="_blank"/g, '')
        data.result.content = data.result.content.replace(/action=restart/g, 'action=restart&device_type=3')
      }

      // 加载loadding,用于延迟
      await delay(1200)
      // 如果有表情，则先添加表情
      if (bq && type === 1) {
        this.addMessage({
          text: [{ content: bq, isbq: true }],
          avatar: 'statics/boy-avatar.png',
          bgColor: 'white'
        })
        await delay(600)
      }
      this.getRading(content)
      // 如果是抛出问题，判断是否有content, 如果有，先抛出content内容引导
      if (type === 3 && content) {
        this.addMessage({
          text: [{ content }],
          avatar: 'statics/boy-avatar.png',
          bgColor: 'white'
        })
        await delay(600)
      }

      // 如果是做题页面，设置做题属性
      let answer = data.result
      if (type === 3 || type === 4 || type === 5) {
        this.ask = {
          input_type: ask.input_type,
          item: {},
          show: false,
          children: ask.children,
          title: ask.title
        }
        console.log('ask:')
        console.log(ask)
        // 设置输入框提示
        this.input = {
          type: ask.input_type,
          placeholder: placeholder[ask.input_type] || '',
          reset: true
        }
        answer = { content: ask.title }
        // 抛出问题，给出提示
        // await this.addMessage({
        //   text: [
        //     {content: '嗯，为给您更准确的分析，还需了解一些相关情况'}
        //   ],
        //   avatar: 'statics/boy-avatar.png',
        //   bgColor: 'white'
        // })
        // await delay(600)
      } else if (type === 7) {
        // 如果是报告，如果没有有长内容，不添加报告显示
        if (data.result.report_content) {
          await this.addMessage({
            text: [{ content: '嗯嗯，您的情况已经收到，现在已经为您分析意见，请点击下方查看' }],
            avatar: 'statics/boy-avatar.png',
            bgColor: 'white'
          })
          await delay(600)
        }
      }

      // 设置答案类型
      this.question_type = type

      // 添加答案
      await this.addMessage({
        text: [answer],
        avatar: 'statics/boy-avatar.png',
        bgColor: 'white',
        type: type
      })
      // 如果是问题类型，显示问题panel
      if (type === 3 || type === 4 || type === 5) {
        this.ask.show = true
      }
      this.loading = false
      console.log('messages')
      console.log(this.messages)
    },
    async addMessage (option) {
      this.messages.push(option)
      this.scrollControll('newmsg')
    },
    openPopover (pop) {
      console.log(pop, 'plkjj')
      this.popover = pop
    },
    getOptionSend () {
      // const option = JSON.stringify(this.check_option)
      this.sendmessage(this.ask.item)
    },
    getOption (type, title, index) {
      if (this.ask.item[index]) {
        this.$delete(this.ask.item, index)
      } else {
        this.ask.item = Object.assign({}, this.ask.item, { [index]: title })
      }
    },
    focus () {
      const _this = this
      this.is_voice = false
      setTimeout(() => {
        let pannel = _this.$refs.enterInput
        pannel.scrollIntoView(true)
      }, 200)
    },
    setScrollTop (num) {
      this.scroll_top = num
    },
    scrollControll (pos, num, time = 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          let node = document.querySelector('#container')
          let chatList = document.querySelectorAll('.message-items-seed')
          let posHeight = num
            ? num - node.clientHeight / 2
            : chatList[chatList.length - 1].offsetTop - 100
          $('#container').animate({ scrollTop: posHeight }, 'normal') // eslint-disable-line
        }, time)
      })
    },
    setAsk (show = false, item = {}, type = '', title = '', children = '') {
      this.ask = {
        show,
        item,
        input_type: type,
        title,
        children
      }
    },
    // 清空搜索结果
    clearQuestionLike () {
      this.question_like = {
        show: false,
        index: -1,
        list: []
      }
    },
    baikeFilter (val, baike) {
      baike.sort(function (a, b) {
        return a[0].length < b[0].length
      })
      // let str = []
      // for (let n in baike) {
      //   str.push(baike[n][0])
      // }
      for (let n in baike) {
        val = val.replace(
          new RegExp('(' + baike[n][0] + ')', 'g'),
          `___${n}___`
        )
      }
      for (let n in baike) {
        const bk = baike[n][0]
        val = val.replace(
          new RegExp('(___' + n + '___)', 'g'),
          `<span class="baike" content="${Base64.encode(
            baike[n][1]
          )}">${bk}</span>`
        )
      }
      return val
    },
    setContent (content) {
      let self = this
      this.reports = {
        content,
        show: true,
        current: 0
      }
      this.$nextTick(() => {
        var obj = document.getElementsByClassName('baike')
        for (var i = 0; i < obj.length; i++) {
          obj[i].onclick = function () {
            self.dailog = {
              show: true,
              content: Base64.decode(this.getAttribute('content')),
              title: this.innerHTML
            }
          }
        }
      })
    },
    async getCaseContent (id) {
      console.log(id)
      this.$loading.show()
      const { data } = await request({
        url: 'https://xiaoxiangs.laway.cn/case/?id=' + id,
        method: 'get'
      })
      if (data.status !== 1) {
        console.log('Log: 返回状态码为' + data.status)
        return false
      }
      console.log(data)
      this.cases = {
        content: data.result,
        show: true
      }
      this.$loading.hide()
    },
    // 朗读答案内容
    /* eslint-disable */
    getRading (content) {
      this.isreading = true
      console.log('开始朗读')
      let txtcon = content
      txtcon = txtcon.replace(/【(\S*)】/gi, '') // 去掉【】及其内容
      txtcon = txtcon.replace(/<[^>]+>/g, '') // 去除HTML标签
      txtcon = txtcon.replace(/(<[^\s\/>]+)\b[^>]*>/gi, '') // 去除HTML标签中的属性
      txtcon = txtcon.replace(/&gt|&lt/gi, '') // 去除gt
      console.log(txtcon, 'ss')
      speak(txtcon)
    },
    stopRading () {
      this.isreading = false
      const speakAudio = document.getElementById('speak')
      speakAudio.pause()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.stopRading()
    next()
  }

}
</script>
<style lang="stylus" >
ul
  margin 0
  padding 0
  list-style none
.saohei_page
  height 100vh
  overflow hidden
  box-sizing border-box
  overflow hidden
  display flex
  flex-direction column
  .report-message
    display flex
    width 12rem
    padding 0.2rem 0 0 0
    justify-content space-between
    .item
      display flex
      border 1px solid #e5e5e5
      flex-direction column
      border-radius 0.1rem
    .item-title
      text-align center
      font-size 0.3rem
      font-weight bold
      padding 0.15rem 0
      border-bottom 1px dashed #e5e5e5
      color #294ea3
    .content
      flex 1
      padding 0.2rem 0.2rem 0.3rem 0.2rem
      .desc
        font-size 0.2rem
        font-weight bold
        padding 0.15rem
        color #333
      .desc-item
        font-size 0.2rem
        padding-left 0.15rem
        line-height 1.6
  a
    color #294ea3
  .saohei_content
    position relative
    display flex
    justify-content space-between
    padding 0 0.6rem 0.9rem 0
    height calc(100% - 1.2rem)
    box-sizing border-box
  .saoheileft
    position relative
    z-index 101
    width 4.08rem
    .imgs
      position absolute
      left 0
      bottom 0
      width 5.9rem
      height 100%
    img
      position absolute
      width 100%
      display block
      bottom 0
  .scroll-box
    position relative
    z-index 102
    width 10.44rem
    background-color #fff
    border-radius 0.3rem
    display flex
    box-sizing border-box
    flex-direction column
    .stopreading
      position absolute
      top -0.2rem
      left -0.2rem
      width 1rem
      height 1rem
      border-radius 50%
      display flex
      justify-content center
      align-items center
      background rgba(48, 192, 54, 0.9)
      img
        width 80%
    .list-box
      position relative
      padding 0.3rem 0.3rem 0 0.3rem
      flex 1
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
    .message-avatar
      display flex
    .message-avatar
      .avatar
        flex-shrink 0
        margin-right 0.32rem
        border-radius 50%
        width 0.99rem
        height 0.99rem
        overflow hidden
        background-size cover
    .message-items-seed
      display flex
      justify-content flex-end
      .content
        background #b6c9f7
        color #333333
        max-width 80%
        padding 0.26rem 0.3rem
        line-height 1.4
        border-radius 0.1rem
        margin-bottom 0.2rem
        font-size 0.22rem
    .message-items
      max-width 7.12rem
      min-height 0.9rem
      background #f2f2f2
      border-radius 0.12rem
      margin-bottom 0.3rem
      min-width 30%
      font-size 0.22rem
      &.message-items--nobg
        background none
        border-radius 0
        .message-items-inner
          background #f2f2f2
          border-radius 0.1rem
          .message-items-inner__wrap
            position relative
      &.message-items-inline
        display flex
        background none
        .content
          color #222
          display flex
          align-items center
          background #f2f2f2
          border-radius 0.1rem
          font-size 0.22rem
      .hts
        font-size 0.26rem
        padding 0.15rem 0.3rem
      .content
        padding 0.24rem 0.3rem
        line-height 1.6
        color #333
        a
          color #2289f2
        span.baike
          color #2289f2
          text-decoration underline
          cursor pointer
        p
          margin-bottom 0.15rem
        .question
          p, div
            display inline
            &.tip
              font-size 0.24rem
              color #999
        .media_svg
          img
            max-width 100%
      ul.list
        color #294ea3
        padding 0 0 0.15rem 0
        li
          margin 0 0.25rem
          font-size 0.22rem
          padding 0.14rem 0
          line-height 1.4
          border-bottom 1px solid rgba(204, 204, 204, 0.63)
          &:last-child
            border 0
      .is-help
        position absolute
        width 1rem
        right -1.2rem
        bottom 0
        .icon
          a
            display flex
            background #fff
            border 1px solid #ccc
            margin-top 0.2rem
            height 0.84rem
            color #666
            align-items center
            justify-content center
            border-radius 0.1rem
            &.current
              color #fc9d0b
              border-color #fc9d0b
            i
              font-size 0.48rem
      .rel-list
        margin 0 0.2rem 0.2rem
        padding 0.2rem 0 0.1rem
        border-top 1px dashed #d7d7d7
        .ht
          font-size 0.26rem
          font-weight 500
          padding-bottom 0.1rem
      .list-icon2
        margin 0
        list-style none
        padding 0 0.2rem
        li
          a
            font-size 0.22rem
            padding 0.1rem 0
            display block
            align-items center
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            max-width 100%
            img
              height 0.64rem
              width auto
              margin-right 0.15rem
    .message-foot
      display flex
      border-radius 0.08rem
      a
        background-color #f2f2f2
        display flex
        flex 1
        justify-content center
        align-items center
        padding 0.3rem
        color #225ACD
        border-radius 0.12rem
        font-size 0.26rem
        &:hover, &:active
          background #ddd
        &:first-child
          margin-right 0.2rem
        i
          font-size 0.22rem
          margin-right 0.05rem
    .input-box
      width 100%
      height 0.98rem
      background-color #fafafa
      border-radius 0px 0px 0.3rem 0.3rem
      display flex
      align-items center
      input
        flex 1
        border 0
        height 100%
        outline none
        background none
        font-size 0.22rem
        color #333
        padding 0 0.3rem
        &:-moz-placeholder
          color #666
          opacity 1
        &:-ms-input-placeholder
          color #666
        &::-webkit-input-placeholder
          color #666
      button
        border 0
        outline none
        margin-right 0.15rem
        font-size 0.22rem
        width 1.6rem
        height 0.7rem
        color #fff
        background-color #294ea3
        border-radius 0.25rem
  .saoheiright
    position relative
    z-index 2
    width 3.78rem
    box-sizing border-box
    background-color #fff
    border-radius 0.3rem
    padding 0.4rem 0.2rem
    display flex
    flex-direction column
    .title
      font-size 0.28rem
      color #294ea3
      text-align center
      line-height 0.36rem
    .content
      flex 1
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item-title
        font-size 0.22rem
        font-weight bold
        padding 0.24rem 0 0.2rem 0
      ul
        li
          padding 0.15rem 0
          font-size 0.18rem
          line-height 1.4
          border-bottom 1px solid #e5e5e5
  @keyframes fade-in-from-right
    0%
      -webkit-transform translate3d(50%, 0, 0)
      transform translate3d(50%, 0, 0)
      opacity 0
    to
      -webkit-transform translateZ(0)
      transform translateZ(0)
      opacity 1
  @keyframes fade-out-from-right
    0%
      -webkit-transform translateZ(0)
      transform translateZ(0)
      opacity 1
    to
      -webkit-transform translate3d(50%, 0, 0)
      transform translate3d(50%, 0, 0)
      opacity 0
  @keyframes fade-in
    0%
      opacity 0
    to
      opacity 1
  @keyframes fade-out
    0%
      opacity 1
    to
      opacity 0
</style>
